import { render } from "./AgreementText.vue?vue&type=template&id=70e25fe6"
import script from "./AgreementText.vue?vue&type=script&lang=js"
export * from "./AgreementText.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__